import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  Accordion as BSAccordion,
  AccordionProps,
  Container,
} from 'react-bootstrap';

export type customAccordionProps = AccordionProps &
  React.PropsWithChildren<{
    title: string;
    subtitle?: string;
    infoIcon?: IconProp;
    titlePercent?: string;
    button?: React.ReactNode;
    activeKey?: string;
    onHandleExpand?: () => void;
  }>;

const Accordion = ({
  title,
  subtitle,
  infoIcon,
  titlePercent,
  button,
  children,
  activeKey,
  onHandleExpand,
  ...props
}: customAccordionProps) => {
  const icon = (iconName: IconProp) => <FontAwesomeIcon icon={iconName} />;

  return (
    <BSAccordion activeKey={activeKey}>
      <BSAccordion.Item
        eventKey={'0'}
        className={`accordion-custom ${!subtitle ? 'single-title' : ''} ${
          props.className
        }`}
      >
        <BSAccordion.Header
          onClick={onHandleExpand}
          className="accordion-header"
        >
          <div className="header-container d-flex flex-row justify-content-between">
            <div className="accordion-title-container">
              <Container>
                <div className="d-flex flex-row align-items-center">
                  <h5 className="accordion-title">{title}</h5>
                  {infoIcon && (
                    <span className="accordion-title-icon">
                      {icon(infoIcon)}
                    </span>
                  )}
                </div>
                {titlePercent && <span>{titlePercent}%</span>}
              </Container>
              <Container>
                <span className="accordion-subtitle">{subtitle}</span>
              </Container>
            </div>
            {button && (
              <Container className="btn-container p-0 m-0 col-4 col-lg-3">
                {button}
              </Container>
            )}
          </div>
        </BSAccordion.Header>
        <BSAccordion.Body>{children}</BSAccordion.Body>
      </BSAccordion.Item>
    </BSAccordion>
  );
};

export default Accordion;
